module.exports = __webpack_public_path__ + "static/img/baokao.9d346cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baokao.png
// module id = 2S2y
// module chunks = 1